import * as z from "zod";
import {
  CommonMetadataSchema,
  type ManifestValidationResult,
  validateManifest,
} from "./_shared.js";

export const RulesetManifestSchema = z.looseObject({
  name: z.string().min(1),
  description: z.string().min(1),
  version: z.string().optional(),
  keywords: z.array(z.string()).optional(),
  license: z.string().optional(),
  metadata: CommonMetadataSchema.optional(),
});

export type RulesetManifest = z.infer<typeof RulesetManifestSchema>;

export function validateRuleset(data: unknown): ManifestValidationResult<RulesetManifest> {
  return validateManifest(RulesetManifestSchema, data);
}
